module.exports = __webpack_public_path__ + "static/media/Services-06.24e7f8e2.jpg";